import { SupplementalEvidenceOption } from '@assess/browser/api';

import { QualityProcedureInputType } from '../enums/quality-procedure-input-type.enum';

export function getQualityProcedureInputType(procedure?: SupplementalEvidenceOption) {
  if (!procedure) return QualityProcedureInputType.None;

  if (procedure?.units !== undefined && !procedure?.inputDropdown) {
    return QualityProcedureInputType.InputBox;
  } else if (procedure?.inputDropdown) {
    return QualityProcedureInputType.Select;
  }

  return QualityProcedureInputType.None;
}
